import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorHandlerInterceptor } from './core/interceptors/error-handler.interceptor';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';

import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AuthService } from './core/services/auth.service';
import { TokenTimerService } from './core/services/token-timer.service';


const initAuthApp = (authService: AuthService) => {
  return async() => {
    await authService.initAuth();
  }
}

const tokenTimer = (tokenTimerService: TokenTimerService) => tokenTimerService.getMainingTime;


export const appConfig: ApplicationConfig = {
  providers: [
    TokenTimerService,
    AuthService,
    {
      provide: APP_INITIALIZER,
      useFactory: initAuthApp,
      deps: [AuthService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: tokenTimer,
      deps: [TokenTimerService],
      multi: true
    },    
    provideRouter(routes), 
    provideAnimations(),    
    provideOAuthClient(),
    importProvidersFrom(
      LoggerModule.forRoot({
        serverLoggingUrl: 'http://localhost:4500/api/logs',
        level: NgxLoggerLevel.DEBUG,
        serverLogLevel: NgxLoggerLevel.ERROR,
      }),        
    ),
    provideHttpClient(
      withInterceptors([
      authInterceptor, 
      errorHandlerInterceptor, 
      loadingInterceptor
    ]))
  ]
};
